import styled, { css } from 'styled-components';

const textStyles = css`
  font-size: 14px;
  line-height: 20px;
  color: #4f6168;
`;

const boldTextStyles = css`
  ${textStyles};
  font-weight: 900;
`;

const NormalTextStyles = css`
  ${textStyles};
  font-weight: 400;
`;

export const Containe = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px 0 24px 0;
  p {
    ${NormalTextStyles}
    span {
      ${boldTextStyles}
    }
  }
`;

export const Button = styled.button`
  width: 226px;
  height: 44px;
  background-color: #00a149;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  :hover {
    background: #007f38;
  }

  :focus {
    background: #005c27;
  }

  :active {
    background: #007f38;
  }

  img {
    width: 20px;
    height: 20px;
  }
  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }
`;
